import { ReactNode } from 'react';
import './style.scss';

interface IProps<T> {
  value: T;
  onClick?: (value: T) => void;
  children?: ReactNode;
}

const DropDownOption = <T,>(props: IProps<T>): JSX.Element => {
  const handleClick = () => {
    if (props.onClick) {
      props.onClick(props.value);
    }
  };

  return (
    // ATTENTION: use mousedown instead of click due to it's priority over blur
    <div onMouseDown={handleClick} className="dropdown-option px-3 py-3  bg_hover-bluelight text-pointer">
      {props.children}
    </div>
  );
};

export default DropDownOption;
